import { render } from "./ModalManutencao.vue?vue&type=template&id=04ee1423&scoped=true"
import script from "./ModalManutencao.vue?vue&type=script&lang=js"
export * from "./ModalManutencao.vue?vue&type=script&lang=js"

import "./ModalManutencao.vue?vue&type=style&index=0&id=04ee1423&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ee1423"]])

export default __exports__